import React, { useContext, useState } from "react";
import {
    MDBNavbar, MDBNavbarBrand, MDBNavbarNav, MDBNavItem, MDBNavLink, MDBNavbarToggler, MDBCollapse, 
    MDBDropdown, MDBDropdownToggle, MDBDropdownMenu, MDBDropdownItem, MDBContainer, MDBIcon
} from "mdbreact";
import { Link } from 'react-router-dom';

import HeaderLoggedIn from "./HeaderLoggedIn";
import HeaderLoggedOut from './HeaderLoggedOut'
import StateContext from '../../StateContext'
import DispatchContext from "../../DispatchContext";

function NavbarPage(props) {

    const [isOpen, setIsOpen] = useState(false)
    const appState = useContext(StateContext)
    const appDispatch = useContext(DispatchContext);
    

    const headerContent = appState.loggedIn ? <HeaderLoggedIn setIsOpen={setIsOpen} /> : <HeaderLoggedOut />

    const toggleCollapse = () => {
        if (isOpen) {
            setIsOpen(false)
        } else {
            setIsOpen(true)
        }
    }


  return (
    
      <MDBNavbar color="white" light expand="md">
          <MDBContainer>
            <MDBNavbarBrand>     
                <Link to="/">
                    <img src="https://camillahardilla.com/wp-content/uploads/2020/07/my-recipes-logo.png" className="img-fluid rounded-circle" style={{maxWidth: "35px"}} alt="Site logo"/>
                </Link>
            </MDBNavbarBrand>
            <MDBNavbarToggler onClick={toggleCollapse} />
            <MDBCollapse id="navbarCollapse3" isOpen={isOpen} navbar>
            <MDBNavbarNav left>
                <MDBNavItem onClick={toggleCollapse} className={appState.currentPage === "latest-recipes" ? "active" : ""}>
                    <MDBNavLink to="/innlegg/1" onClick={() => appDispatch({type: "currentPage", value: "latest-recipes"})}>Lates recipes</MDBNavLink>
                </MDBNavItem>
                <MDBNavItem onClick={toggleCollapse} className={appState.currentPage === "discover" ? "active" : ""}>
                    <MDBNavLink to="/discover" onClick={() => appDispatch({type: "currentPage", value: "discover"})}><i className="far fa-compass"></i> Discover</MDBNavLink>
                </MDBNavItem>

               

                {appState.wordpressSite === "bp-social" &&
                    <>
                    <MDBNavItem>
                        <MDBDropdown>
                            <MDBDropdownToggle nav caret>
                            <MDBIcon icon="movie" /> Media
                            </MDBDropdownToggle>
                                <MDBDropdownMenu onClick={toggleCollapse} className="dropdown-default">
                                    <MDBDropdownItem><Link to="/movies/1">Filmer</Link></MDBDropdownItem>
                                    <MDBDropdownItem><Link to="/shows/1">Serier</Link></MDBDropdownItem>
                                    <MDBDropdownItem><Link to="/search-movies">Søk filmer</Link></MDBDropdownItem>
                                    <MDBDropdownItem><Link to="/search-shows">Søk serier</Link></MDBDropdownItem>
                            </MDBDropdownMenu>
                        </MDBDropdown>
                    </MDBNavItem>
                    <MDBNavItem>
                        <MDBNavLink to="/fm/vidunderbarn-table">FM</MDBNavLink>
                    </MDBNavItem>
                    </>
                }
                {appState.wordpressSite === "min-kokebok" && (
                    <>
                  
                    </>
                )}

            </MDBNavbarNav>

            {!props.staticEmpty ? headerContent : ""}

            </MDBCollapse>
        </MDBContainer>
      </MDBNavbar>
    );
  }


export default NavbarPage;